export const FORM_DEBOUNCE_DELAY = 300; // Reduced from 1200ms to 300ms for faster responsiveness
export const FORM_DEBOUNCE_DELAY_SHORT = 100; // Reduced from 200ms to 100ms for faster responsiveness
export const DATE_FORMAT_STRING = "MM/dd/yy 'at' h:mm a";

export const FEATURE_FLAGS = {
  useEmailVerification: 'cinch-email-verification',
  useEmbeddedSignNow: 'cinch-embedded-signnow',
};

export const IMAGETYPE_JPEG = 'image/jpeg';

export const LIABILITY_MAX_REMAINING_MONTHS = 3000;
